module.exports = __webpack_public_path__ + "img/basic-mic.94e484ca.svg";